import { render, staticRenderFns } from "./IndexSignUp.vue?vue&type=template&id=66e66ed6&scoped=true&"
import script from "./IndexSignUp.vue?vue&type=script&lang=js&"
export * from "./IndexSignUp.vue?vue&type=script&lang=js&"
import style0 from "./IndexSignUp.vue?vue&type=style&index=0&id=66e66ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e66ed6",
  null
  
)

export default component.exports